<template>
	<div class="main">
	<el-container style="height:100%;" direction="vertical">
	  <el-main>
	<a-list item-layout="horizontal" :data-source="xmlist" split="true">
		<a-list-item slot="renderItem" slot-scope="item, index">
			<a slot="actions"><a-button @click="datascnew(index)" size="small"> 数据管理 </a-button></a>
			<a slot="actions"><a-button @click="jindusc()" size="small"> 进度统计 </a-button></a>
			<a slot="actions"><a-button @click="baobiao()" size="small"> 成绩报表 </a-button></a>
   
		<a-list-item-meta
			:description="item.children">
			<a slot="title">{{ item.label }}</a>
			
			<a-avatar
			slot="avatar"
			style="backgroundColor:#87d068" icon="database" 
			/>
			
			
		</a-list-item-meta>
		
		</a-list-item>
	</a-list>

	
	  </el-main>
				
		</el-container>
	</div>
	
	
	
	</template>
	
	<script>
	import axios from 'axios'
	import qs from 'qs'
	import localStorage from 'localStorage'

	export default {
		data() {
		  return {
			xmlist: [],
			defaultProps: {
			   children: 'children',
						label: 'label',
						level: 'level'
					},
				sel_xm:'',
				sel_sb:'',
				sel_tizu:'',
				is_disable:true,
				is_jindu_disable:true,
				options:[],
				cascagerdefault: ["0", "0", ""],
				datalist:[
						{
							title: 'Ant Design Title 1',
						},
						{
							title: 'Ant Design Title 2',
						},
						{
							title: 'Ant Design Title 3',
						},
						{
							title: 'Ant Design Title 4',
						},
						],
										
		  };
		},
	
		mounted:function(){
			 
	
			  this.getopt();//需要触发的函数
		},
		
	
		methods: {
		
 
		 
			getopt(){
		
					console.log('请求开始');
					//发送get请求
					this.$http.get('/scoreman?op=schoolmanxm').then(function(res){
				
									console.log(res.data);
									this.xmlist=res.data;
									
					  			console.log('请求结束');
			
					},function(){
						console.log('请求失败处理');
					});
			},
	
			datascnew(index){	
				let xm=this.xmlist[index]['label'];
				let kemu=this.xmlist[index]['children'];

				localStorage.setItem('xm',xm);
				localStorage.setItem('kemu',kemu);
				localStorage.setItem('svr_yuming',this.xmlist[index]['svr_yuming']);
			
						//this.selTizu();						
				this.$router.push({ path: '/datasc', query: { xm: xm,subject: this.sel_sb,tizu:this.sel_tizu }});
			},

		 
			datasc(index, row){	
				let xm=this.xmlist[index]['label'];
				let kemu=this.xmlist[index]['children'];

				localStorage.setItem('xm',xm);
				localStorage.setItem('kemu',kemu);
			
						//this.selTizu();						
				this.$router.push({ path: '/datasc', query: { xm: xm,subject: this.sel_sb,tizu:this.sel_tizu }});
			},

			uploadsc(index){	
				let xm=this.xmlist[index]['label'];
				let kemu=this.xmlist[index]['children'];

				localStorage.setItem('xm',xm);
				localStorage.setItem('kemu',kemu);
			
						//this.selTizu();						
				this.$router.push({ path: '/uploadsc', query: { xm: xm,subject: this.sel_sb,tizu:this.sel_tizu }});
			},
			jindusc(){
	 
				this.$router.push({ path: '/yuejuansc', query: { xm: this.sel_xm,subject: this.sel_sb,tizu:this.sel_tizu }});			
				
			},
			baobiao(){
	 
				this.$router.push({ path: '/scoresc', query: { xm: this.sel_xm,subject: this.sel_sb,tizu:this.sel_tizu }});					
				
			},
	
		}
	  };
	</script>
	
	<!-- Add "scoped" attribute to limit CSS to this component only -->
	<style scoped>
		html,
		body,
		#app,
		.main,
		.el-container {
			padding: 0px;
			margin: 0px;
			height: 100%;
	
		}
	
	  .el-tree{
		background: #f0f9eb;
	  }
	
	  .el-cascader-menu {
	  height: 300px;
	}
	
	.el-cascader-panel {
	  height:auto;
	}
	
	.mainbody {
	 
	   min-height: 100%;
	}
	
	.el-row {
		margin-bottom: 20px;
		&:last-child {
		  margin-bottom: 0;
		}
	  }
	  .el-col {
		border-radius: 4px;
	  }
	
	  .grid-content {
		border-radius: 4px;
		min-height: 36px;
	  }
	  .row-bg {
		padding: 10px 0;
		background-color: #f9fafc;
	  }
	
	</style>
	